import { Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography, styled } from "@mui/material";
import { FC, useContext } from "react";
import InputOnlyField from "@/components/forms/fields/inputOnly/InputOnlyField";
import Markdown from "@/components/forms/inputs/Markdown";
import Text from "@/components/forms/inputs/Text";
import Field from "../../fields/Field";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { AppSettings } from "@/AppSettings";
import TrialContext from "@/contexts/data/TrialContext";
import { useScopedField } from "@ngt/forms-core";
import AlertMarkdown from "../../inputs/AlertMarkdown";
import { DetailsListItem, DetailsListItemButton, DetailsListItemIcon, DetailsListItemText } from "./ConfigurationSourceDataFormDetails";
import ConfigurationSourceDataFormContext from "@/contexts/form/ConfigurationSourceDataFormContext";


const FormContainer = styled(Paper)(({ theme }) => ({ 
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
}));

const ListContainer = styled(Paper)(({ theme }) => ({ 
    marginBottom: theme.spacing(2)
}));

interface IConfigurationSourceDataForm {
}

export const ValidateConfigurationSourceDataForm = () => {
    
}

const ConfigurationSourceDataForm: FC<IConfigurationSourceDataForm> = ({}) => {
    const { data: trial } = useContext(TrialContext);

    const { state: { value: configurationSourceDataId }} = useScopedField<number>('configuration.configuration.id', { value: true })
    const { state: { value: isGlobal }} = useScopedField<boolean>('configuration.configuration.isGlobal', { value: true });

    const { baseRoute } = useContext(ConfigurationSourceDataFormContext);
    const parentRoute = baseRoute ? baseRoute : `/${trial?.oid}/configuration/source-data/${isGlobal ? 'trial' : configurationSourceDataId ? configurationSourceDataId : 'new'}`


    return (
        <Field propertyPath="configuration.configuration">
            <Typography variant="h2" gutterBottom>
                Details
            </Typography>
            <FormContainer>
                <InputOnlyField
                    propertyPath="name"
                    label="Name"
                    helperText="Enter a name for the configuration."
                    margin="normal"
                    component={Text}
                />
                <InputOnlyField
                    propertyPath="description"
                    label="Description"
                    helperText="Enter a description of the configuration."
                    margin="normal"
                    component={Text}
                />
            </FormContainer>
            { 
                !isGlobal && (
                    <>
                        <Typography variant="h2" gutterBottom>
                            Messages
                        </Typography>
                        <FormContainer>
                            <InputOnlyField
                                propertyPath="alertSuccess"
                                label="Message - Success Styling"
                                helperText={`Enter a message that will be displayed in success styling (green) at the top of every page related to this configuration.`}
                                margin="normal"
                                component={AlertMarkdown}
                                severity="success"
                            />
                            <InputOnlyField
                                propertyPath="alertInformation"
                                label="Message - Information Styling"
                                helperText={`Enter a message that will be displayed in information styling (blue) at the top of every page related to this configuration.`}
                                margin="normal"
                                component={AlertMarkdown}
                                severity="info"
                            />
                            <InputOnlyField
                                propertyPath="alertWarning"
                                label="Message - Warning Styling"
                                helperText={`Enter a message that will be displayed in warning styling (yellow) at the top of every page related to this configuration.`}
                                margin="normal"
                                component={AlertMarkdown}
                                severity="warning"
                            />
                            <InputOnlyField
                                propertyPath="alertError"
                                label="Message - Error Styling"
                                helperText={`Enter a message that will be displayed in error styling (red) at the top of every page related to this configuration.`}
                                margin="normal"
                                component={AlertMarkdown}
                                severity="error"
                            />
                        </FormContainer>
                    </>
                )
            }
            <Typography variant="h2" gutterBottom>
                Related
            </Typography>
            <ListContainer>
                <List disablePadding>
                    <DetailsListItem 
                        disablePadding
                    >
                        <DetailsListItemButton
                            //@ts-ignore-next-line
                            component={Link} 
                            to={`${parentRoute}/events`}
                        >
                            <DetailsListItemIcon>
                                <FontAwesomeIcon fixedWidth size="lg" icon={AppSettings.icons.event} />
                            </DetailsListItemIcon>
                            <DetailsListItemText 
                                primary="Events" 
                            />
                        </DetailsListItemButton>
                    </DetailsListItem>
                    <Divider />
                    <DetailsListItem 
                        disablePadding
                    >
                        <DetailsListItemButton
                            //@ts-ignore-next-line
                            component={Link} 
                            to={`${parentRoute}/forms`}
                        >
                            <DetailsListItemIcon>
                                <FontAwesomeIcon fixedWidth size="lg" icon={AppSettings.icons.form} />
                            </DetailsListItemIcon>
                            <DetailsListItemText 
                                primary="Forms" 
                            />
                        </DetailsListItemButton>
                    </DetailsListItem>
                    <Divider />
                </List>
            </ListContainer>
        </Field>
    );
};

export default ConfigurationSourceDataForm;